module.exports = "<div> <ul class=c-explore-by> <facet v-for=\"(f, index) in terms\" :key=f.name :children=f.children :nested=false :name=f.name :count=f.count :visible=\"expanded || index < 5\" :url=f.url /> </ul> <button role=switch :aria-checked=\"expanded + ''\" :title=\"trans(title) + ': ' + trans(expanded ? 'show less' : 'show more')\" class=c-explore-by__show-more v-on:click=\"expanded = !expanded\"> {{ expanded ? trans(\"show less\") : trans(\"show more\") }} </button> <div role=presentation class=u-clearfix></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/pages/explore-the-archive/templates/faceted-list.html
// module id = 127
// module chunks = 0